import { state as detailPreviewState } from './detail_preview';

export const states = [detailPreviewState.AuditDetailPreviewState];
